<div class="modal fade" [class.show]="show">
  <div
    class="modal-dialog modal-dialog-centered"
    [ngClass]="'modal-' + size"
    tabindex="-1"
    role="dialog"
    atxClickOutside
    (clickOutside)="clickOutside()"
  >
    <div class="modal-content">
      @if (showCloseBtn) {
      <button
        type="button"
        class="close btn btn-round"
        data-dismiss="modal"
        aria-label="Close"
        (click)="close()"
      >
        <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
      </button>
      }
      <ng-content select=".modal-header"></ng-content>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
      <ng-content select=".modal-footer"></ng-content>
    </div>
  </div>
</div>
@if (show) {
<div class="modal-backdrop fade show"></div>
}
